<template>
    <div>
    <form class="item-editor-form">
        <fg-input v-model="name" :label="$t('powersockets.name')" :disabled="loading"></fg-input>
        <fg-input v-model="description" :label="$t('powersockets.description')" :disabled="loading"></fg-input>
        <b-form-group :label="$t('powersockets.type')">
            <vSelect :options="typeOptions" v-model="type" :reduce="option => option.id" label="name" :disabled="loading"/>
        </b-form-group>
        <fg-input v-model="ip" :label="$t('powersockets.ip')" :disabled="loading"></fg-input>
        <fg-input v-model="username" :label="$t('powersockets.username')" :disabled="loading"></fg-input>
        <fg-input v-model="password" :label="$t('powersockets.password')" :disabled="loading"></fg-input>
        <b-form-group :label="$t('powersockets.controller')">
            <b-input-group v-for="controller in controllers" :key="controller">
                <b-form-input :readonly="true" :value="controller"></b-form-input>
                <b-input-group-append>
                    <button type="button" :value="controller" @click="onRemoveController(controller)">{{ $t('button.remove') }}</button>
                </b-input-group-append>
            </b-input-group>
            <InfopointSelect @input="onControllerInput"  :disabled="loading"/>
        </b-form-group>
        <b-form-group :label="$t('powersockets.controlled')">
            <b-input-group v-for="slave in slaves" :key="slave">
                <b-form-input :readonly="true" :value="slave"></b-form-input>
                <b-input-group-append>
                    <button type="button" :value="slave" @click="onRemoveSlave(slave)">{{ $t('button.remove') }}</button>
                </b-input-group-append>
            </b-input-group>
            <vSelect :options="slaveOptions" :reduce="option => option.id" label="name" @input="onSlaveInput"  :disabled="loading" />
        </b-form-group>
        
        <FormButtons
            @submit="submit" 
            :reset="false" 
            :remove="action == 'edit'" 
            @remove="remove"
            :disableSubmit="loading"
            :disableRemove="loading "/>


            <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>

    <b-modal id="modal-delete" static @ok="onDeleteOK" :title='$t("powersockets.delete.prompt_title")'>
        {{ $t("powersockets.delete.prompt_message") }}
    </b-modal>
    
    <b-toaster name="paahdin" class="b-toaster-top-right"></b-toaster>
    </div>
</template>

<script>

import InfopointSelect from '@/components/Display/InfopointSelect'
import device from '@/store/displays/device'
import vSelect from 'vue-select'

import {Tag} from 'element-ui'

export default {
    components: {
        InfopointSelect,
        vSelect,
        [Tag.name]: Tag
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => {}
        },
        action: { default: "new" }
    },
    data() {
        return {
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },
    computed: {
        typeOptions: function() {
            var optionList = [];
            for (var type of this.$store.state.device.deviceTypeList) {
                if (type.value.toLowerCase().indexOf('power') != -1)
                    optionList.push({ id: type.value, name: type.text });
            }
            return optionList;
        },
        slaveOptions: function() {
            var optionList = [];
            for (var device of this.$store.state.device.deviceList) {
                if (device.type && device.type.toLowerCase().indexOf('power') == -1)
                    optionList.push({ id: device.deviceId, name: device.name });
            }
            return optionList;
        },
        name: {
            get: function() {
                return this.value.name;
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['name']: newValue });
            }
        },
        description: {
            get: function() {
                return this.value.description;
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['description']: newValue });
            }
        },
        type: {
            get: function() {
                return this.value.type;
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['type']: newValue });
            }
        },
        ip: {
            get: function() {
                return this.value.ip;
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['ip']: newValue, ['attributes']: this.addAttribute('IP', newValue) });
            }
        },
        username: {
            get: function() {
                return this.value.username;
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['username']: newValue, ['attributes']: this.addAttribute('Username', newValue) });
            }
        },
        password: {
            get: function() {
                return this.value.password;
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['password']: newValue, ['attributes']: this.addAttribute('Password', newValue) });
            }
        },
        controllers: {
            get: function() {
                if (this.value.controlInfopoints) {
                    return [...this.value.controlInfopoints].sort();
                } else {
                    return this.value.controlInfopoints;
                }
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['controlInfopoints']: newValue, ['attributes']: this.addAttribute('Control_Infopoint', newValue) });
            }
        },
        slaves: {
            get: function() {
                if (this.value.slaveDevices) {
                 return [...this.value.slaveDevices].sort();
                } else {
                    return this.value.slaveDevices;
                }
            },
            set: function(newValue) {
                this.$emit('input', { ...this.value, ['slaveDevices']: newValue, ['attributes']: this.addAttribute('Slave_Device', newValue) });
            }
        }
    },
    methods: {
        submit(event) {
            if(event) event.preventDefault();
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = this.disabled = true;

            this.$store.dispatch('powerSocket/savePowerSocket', this.value).then(response => {
                setTimeout(() => { 
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                    this.loading = this.disabled = false;
                }, 1000);
             })
            .catch( () => { this.error = true; }) 
            .finally( ); 

            /*


            this.$bvToast.toast(this.$t("notify.saving"), {
                title: this.$t('notify.notice'),
                variant: 'success',
                autoHideDelay: 2000,
                toaster: 'paahdin'
            });
            this.$store.dispatch('powerSocket/savePowerSocket', this.value).then(() => {
                this.$bvToast.toast(this.$t("notify.saved"), {
                    title: this.$t('notify.notice'),
                    variant: 'success',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            }, () => {
                this.$bvToast.toast(this.$t("notify.saving_failed"), {
                    title: this.$t('notify.notice'),
                    variant: 'danger',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            }).catch()
                .then(() => {
                    this.$emit('input', {});
                });

            */
        },
        reset(event) {
            event.preventDefault();
            alert("reset");
        },
        remove() {
            this.$bvModal.show('modal-delete')
        },
        onDeleteOK() {
            this.$store.dispatch('powerSocket/deletePowerSocket', this.value.deviceId).then(() => {
                this.$bvToast.toast(this.$t("notify.deleted"), {
                    title: this.$t('notify.notice'),
                    variant: 'success',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            }, () => {
                this.$bvToast.toast(this.$t("notify.deleting_failed"), {
                    title: this.$t('notify.notice'),
                    variant: 'danger',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            })
                .catch()
                .then(() => {
                    this.$emit('input', {});
                })
        },
        addAttribute(newName, newValue) {
            var newAttributes = [];
            if (this.value.attributes) {
                for (var attrib of this.value.attributes) {
                    if (attrib.name.toLowerCase() != newName.toLowerCase()) {
                        newAttributes.push(attrib);
                    }
                }
            }
            if (Array.isArray(newValue)) {
                for (var newVal of newValue) {
                    newAttributes.push({ name: newName, value: newVal });
                }
            } else {
                newAttributes.push({ name: newName, value: newValue });
            }
            return newAttributes;
        },
        onControllerInput(value) {
            var infopointId = this.$store.getters['infopoint/getInfopointById'](value).uniqueId;
            if (!this.controllers) {
                this.controllers = [infopointId];
            } else if (!this.controllers.includes(infopointId)) {
                this.controllers = [...this.controllers, infopointId].sort();
            }
        },
        onRemoveController(value) {
            if (this.controllers && this.controllers.includes(value)) {
                var newControllers = [...this.controllers];
                newControllers.splice(newControllers.indexOf(value), 1);
                this.controllers = newControllers;
            }
        },
        onSlaveInput(value) {
            if (!this.slaves) {
                this.slaves = [value];
            } else if (!this.slaves.includes(value)) {
                this.slaves = [...this.slaves, value].sort();
            }
        },
        onRemoveSlave(value) {
            if (this.slaves && this.slaves.includes(value)) {
                var newSlaves = [...this.slaves];
                newSlaves.splice(newSlaves.indexOf(value), 1);
                this.slaves = newSlaves;
            }
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.device) {
             this.$store.registerModule("device", device);
        }
        this.$store.dispatch('device/getDeviceTypeList');
    }
}
</script>
